import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSafeTranslation } from '../hooks/useSafeTranslation';

export interface XpPotionReminderModalProps {
  show: boolean;
  onHide: () => void;
  onGoToInventory: () => void;
  onContinueWithoutBonus: () => void;
}

/**
 * Shown before opening solo confirm or PvP create-room when the player still has
 * XP potion items in inventory (unused).
 */
const XpPotionReminderModal: React.FC<XpPotionReminderModalProps> = ({
  show,
  onHide,
  onGoToInventory,
  onContinueWithoutBonus,
}) => {
  const { t } = useSafeTranslation();

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{t('quiz.xpPotionReminderTitle', 'XP potion in inventory')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          {t(
            'quiz.xpPotionReminderBody',
            'You have XP potion items in your inventory. Use them before playing to earn bonus XP on your rewards.'
          )}
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex flex-column flex-md-row gap-2 align-items-center justify-content-md-between">
        <Button variant="outline-secondary" onClick={onContinueWithoutBonus}>
          {t('quiz.xpPotionReminderContinueWithoutBonus', 'Continue without XP bonus')}
        </Button>
        <Button variant="primary" onClick={onGoToInventory}>
          <i className="bi bi-bag me-2" aria-hidden />
          {t('quiz.xpPotionReminderGoInventory', 'Go to inventory')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default XpPotionReminderModal;
